var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-container"},[_c('router-view',{attrs:{"id":"change-view"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }